module.exports = __webpack_public_path__ + "static/media/black_right.377de0c3.png";